module.exports = __webpack_public_path__ + "static/img/acessodigital-logo.0b299e79.png";